var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4028 21.2086L11.2263 17.9437H15.2516L16.075 21.2086H10.4028Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8785 2.53516H4.58847C4.209 2.56585 3.85682 2.74456 3.60798 3.03269C3.35914 3.32082 3.2336 3.69526 3.25847 4.07516V16.4152C3.2336 16.7951 3.35914 17.1695 3.60798 17.4576C3.85682 17.7458 4.209 17.9245 4.58847 17.9552H21.8785C22.2597 17.927 22.6144 17.7493 22.8654 17.4609C23.1163 17.1725 23.2432 16.7967 23.2185 16.4152V4.07516C23.2432 3.69365 23.1163 3.31781 22.8654 3.0294C22.6144 2.74099 22.2597 2.56336 21.8785 2.53516Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22021 14.6465H23.2808",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67432 21.2148H18.7843C19.1295 21.2148 19.4093 21.4947 19.4093 21.8398C19.4093 22.185 19.1295 22.4648 18.7843 22.4648H7.67432C7.32914 22.4648 7.04932 22.185 7.04932 21.8398C7.04932 21.4947 7.32914 21.2148 7.67432 21.2148Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2388 17.293C13.4366 17.293 13.6299 17.2343 13.7943 17.1244C13.9588 17.0146 14.087 16.8584 14.1626 16.6757C14.2383 16.4929 14.2581 16.2919 14.2196 16.0979C14.181 15.9039 14.0857 15.7257 13.9459 15.5859C13.806 15.446 13.6278 15.3508 13.4339 15.3122C13.2399 15.2736 13.0388 15.2934 12.8561 15.3691C12.6734 15.4448 12.5172 15.5729 12.4073 15.7374C12.2974 15.9018 12.2388 16.0952 12.2388 16.293C12.2388 16.5582 12.3441 16.8125 12.5317 17.0001C12.7192 17.1876 12.9736 17.293 13.2388 17.293Z",
    fill: "#00C65E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/icon10.c3d4312c788866ea97bfc395875dc7ce.svg";
export { ForwardRef as ReactComponent };